import { render, staticRenderFns } from "./AveragePriceOverTime.vue?vue&type=template&id=550cbdd0&scoped=true&"
import script from "./AveragePriceOverTime.vue?vue&type=script&lang=js&"
export * from "./AveragePriceOverTime.vue?vue&type=script&lang=js&"
import style0 from "./AveragePriceOverTime.vue?vue&type=style&index=0&id=550cbdd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550cbdd0",
  null
  
)

export default component.exports